
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-lg flex items-center justify-center">
                <i className="ri-brain-line text-white text-xl"></i>
              </div>
              <div className="text-white font-bold text-lg">南湖AI教育</div>
            </div>
            <p className="text-gray-400 leading-relaxed mb-6">
              依据《浙江省中小学人工智能通识教育指导意见》，为南湖区中小学生提供系统化AI素养培育平台
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-wechat-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-weibo-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-qq-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold mb-6">学段入口</h4>
            <ul className="space-y-3">
              <li><Link to="/primary" className="hover:text-white transition-colors cursor-pointer">小学版块（1-6年级）</Link></li>
              <li><Link to="/middle" className="hover:text-white transition-colors cursor-pointer">初中版块（7-9年级）</Link></li>
              <li><Link to="/teacher" className="hover:text-white transition-colors cursor-pointer">教师智教端</Link></li>
              <li><Link to="/admin" className="hover:text-white transition-colors cursor-pointer">校级管理后台</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-6">核心功能</h4>
            <ul className="space-y-3">
              <li><Link to="/primary/magic-drawing" className="hover:text-white transition-colors cursor-pointer">神奇画板</Link></li>
              <li><Link to="/features/agent-builder" className="hover:text-white transition-colors cursor-pointer">智能体搭建工坊</Link></li>
              <li><Link to="/features/neural-network" className="hover:text-white transition-colors cursor-pointer">神经网络实验室</Link></li>
              <li><Link to="/features/assessment" className="hover:text-white transition-colors cursor-pointer">素养评价系统</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-6">支持与服务</h4>
            <ul className="space-y-3">
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">使用文档</a></li>
              <li><Link to="/teacher" className="hover:text-white transition-colors cursor-pointer">教师培训</Link></li>
              <li><a href="#contact" className="hover:text-white transition-colors cursor-pointer">技术支持</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">隐私政策</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">服务条款</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © 2024 南湖区中小学AI通识教育平台. All rights reserved.
            </div>
            <div className="flex items-center space-x-6 text-sm">
              <a href="#" className="hover:text-white transition-colors cursor-pointer">浙ICP备XXXXXXXX号</a>
              <a href="#" className="hover:text-white transition-colors cursor-pointer">浙公网安备XXXXX号</a>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">Powered by Readdy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
